
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.013 15.98a3.999 3.999 0 004.003-3.994V5.994A3.999 3.999 0 0015.013 2H5.003A3.999 3.999 0 001 5.994v12.483a.5.5 0 00.5.499.49.49 0 00.35-.15l2.003-1.997a3.007 3.007 0 012.152-.849h9.008zm-12.011-.998V5.994a2 2 0 012.002-1.997h10.009a2 2 0 012.002 1.997v5.992a2 2 0 01-2.002 1.997H6.005c-1.083 0-2.137.35-3.003.998zm10.51-4.993h1a.5.5 0 00.5-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5zm-4.004 0h1a.5.5 0 00.501-.5v-.998a.5.5 0 00-.5-.5H9.508a.5.5 0 00-.5.5v.998a.5.5 0 00.5.5zm-2.503-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5h1.001a.5.5 0 00.5-.5zm14.013-3.495v7.989a3.999 3.999 0 01-4.003 3.994H5.004a2 2 0 002.001 1.997h11.01c.8-.002 1.567.315 2.132.88l2.002 1.996a.491.491 0 00.35.15.5.5 0 00.501-.5V7.992a2 2 0 00-1.982-1.997z","fill":"#000"}})])
          )
        }
      }
    